module.exports = __webpack_public_path__ + "static/media/PaymentConfirmationScreen.ff97feff.png";